export const Flash = () => ({
  show: true,

  init() {
    setTimeout(() => {
      this.show = false
    }, 5000)
  },

  close() {
    this.show = false
  },
})
